import { useState } from "react"
import React from 'react'
import { ethers, BigNumber } from "ethers"
import abi_contract from './abi.json'
import './mint.css'



const contractAddress = "0x7A013B21bF13f50fDb9871b3016Fd78432f0F742"


const Mint = () => {
    const [text, setText] = useState("");

    const ErrorCompiler = () => {

    return (
    <>
    <div className="error-message">
    <p>{text}</p>
    </div>
    </>
    );
}
    const [accounts, setAccounts] = useState([]);
    const [mintAmount, setMintAmount] = useState(1);
    const isConnected = Boolean(accounts[0]);
   




   async function handleMint() {
        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum)
            const signer = provider.getSigner()
            const contract = new ethers.Contract(contractAddress, abi_contract, signer)

            
            const freeCheck = await contract.checkCost(mintAmount);
            

            try{
                await contract.estimateGas.mint(BigNumber.from(mintAmount),{
                    value: (freeCheck).toString(),
                    // gasLimit: 200000

                 }).then(async function(result){
                const response = await contract.mint(BigNumber.from(mintAmount),{ 
                    value: (freeCheck).toString(),
                    // gasLimit: 200000
                 })

                 console.log(response)
                }).catch(function(error){
                    console.log(error)
                    setText(error.error.message)
                })
                
            }catch(e){
                console.log("error", e)
            }
        }
        
    }
    const handleDecrement = () => {
        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);
    }
    const handleIncrement = () => {
        if (mintAmount >= 10) return;

        setMintAmount(mintAmount + 1);
    }

    async function connectAccount(){
        

        if (window.ethereum) {
            const accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
            setAccounts(accounts);
        }

    }



    return (
        <>

        {isConnected ? (

            <div className="Dapp-mint">
            <ErrorCompiler/>
            <div>
              <p className="DappText">Bring your Cool Bastards to life!</p><br/>
            <input min="1" max="3" type="number" value={mintAmount} onChange={(e) => setMintAmount(e.target.value)} />
            
            </div>
            <div>
                
            <span className="Btn" onClick={handleDecrement}>-</span>
            <span className="Btn" onClick={handleMint}>Mint</span>
            <span className="Btn" onClick={handleIncrement}>+</span>
            </div>

            <p className="DappText"> Please refresh the page 
            <br/>after successfully minting or changing accounts! </p>
            </div>
        
        ) : (
            <>

                <span className="Btn" onClick={connectAccount}>Connect</span>            
                </>
        )}

        </>
        );
}


export default Mint